import { ISolResponse, IUpdateUser, IUpdateUserOID, IUserData, IUserDetailData } from "@/entities";
import {
  BACKEND_BASE_URL,
  IPageResponse,
  IResponseError,
  IUserRequest,
  IUsersReportRequest,
} from "@/services";
import { IUserService } from "@/services/backend/user/user.types";
import { handleResponse } from "@/services/handlers";
import Vue from "vue";

export class UserService implements IUserService {
  async getLoggedUser(): Promise<IUserDetailData | undefined> {
    const { response, error } = await handleResponse<IUserDetailData, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/user/me`)
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async getUsersPage(userRequest?: IUserRequest): Promise<IPageResponse<IUserData> | undefined> {
    const { response, error } = await handleResponse<IPageResponse<IUserData>, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/user`, { params: userRequest })
    );

    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }
  async getUserDetail(idUser: number): Promise<IUserDetailData | undefined> {
    const { response, error } = await handleResponse<IUserDetailData, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/user/` + idUser)
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async updateOIDSol(idUser: number, updateUser: IUpdateUserOID): Promise<string | undefined> {
    const { response, error } = await handleResponse<string, IResponseError>(
      Vue.$axios.patch(
        `${BACKEND_BASE_URL}/api/configuration/v1/user/` + idUser + `/oid`,
        updateUser
      )
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async updateUser(idUser: number, updateUser: IUpdateUser): Promise<ISolResponse | undefined> {
    const { response, error } = await handleResponse<ISolResponse, IResponseError>(
      Vue.$axios.post(`${BACKEND_BASE_URL}/api/configuration/v1/user/` + idUser, updateUser)
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async addUserServicepointApproval(
    idUser: number,
    updateUser: IUpdateUser
  ): Promise<boolean | undefined> {
    const { response, error } = await handleResponse<ISolResponse, IResponseError>(
      Vue.$axios.post(
        `${BACKEND_BASE_URL}/api/configuration/v1/user/` + idUser + `/service-point-approvals`,
        updateUser
      )
    );
    if (error) {
      return undefined;
    } else {
      return response?.status === 200;
    }
  }

  async removeUserServicepoint(
    idUser: number,
    updateUser: IUpdateUser
  ): Promise<ISolResponse | undefined> {
    const { response, error } = await handleResponse<ISolResponse, IResponseError>(
      Vue.$axios.post(
        `${BACKEND_BASE_URL}/api/configuration/v1/user/` + idUser + `/remove/service-point`,
        updateUser
      )
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async removeUserServicepointApprovals(
    idUser: number,
    updateUser: IUpdateUser
  ): Promise<boolean | undefined> {
    const { response, error } = await handleResponse<ISolResponse, IResponseError>(
      Vue.$axios.post(
        `${BACKEND_BASE_URL}/api/configuration/v1/user/` +
          idUser +
          `/remove/service-point-approvals`,
        updateUser
      )
    );
    if (error) {
      return undefined;
    } else {
      return response?.status === 200;
    }
  }

  async toggleAdmin(idUser: number): Promise<boolean | undefined> {
    const { response, error } = await handleResponse<boolean, IResponseError>(
      Vue.$axios.put(`${BACKEND_BASE_URL}/api/configuration/v1/user/admin/` + idUser)
    );
    if (error) {
      return false;
    } else {
      return response?.data;
    }
  }
  async toggleSupervisor(idUser: number): Promise<boolean | undefined> {
    const { response, error } = await handleResponse<boolean, IResponseError>(
      Vue.$axios.put(`${BACKEND_BASE_URL}/api/configuration/v1/user/supervisor/` + idUser)
    );
    if (error) {
      return false;
    } else {
      return response?.data;
    }
  }

  async toggleAprobador(idUser: number): Promise<boolean | undefined> {
    const { response, error } = await handleResponse<boolean, IResponseError>(
      Vue.$axios.patch(`${BACKEND_BASE_URL}/api/configuration/v1/user/approver/` + idUser)
    );
    if (error) {
      return false;
    } else {
      return response?.data;
    }
  }

  async acceptDisclaimer(): Promise<void> {
    await handleResponse<Promise<void>, IResponseError>(
      Vue.$axios.patch(`${BACKEND_BASE_URL}/api/configuration/v1/user/disclaimer/acceptance`)
    );
  }
  async declineDisclaimer(): Promise<void> {
    await handleResponse<Promise<void>, IResponseError>(
      Vue.$axios.patch(`${BACKEND_BASE_URL}/api/configuration/v1/user/disclaimer/decline`)
    );
  }

  async saveUsersReport(requestBody?: IUsersReportRequest): Promise<void> {
    await handleResponse<Promise<void>, IResponseError>(
      Vue.$axios.post(`${BACKEND_BASE_URL}/api/configuration/v1/report/users`, requestBody)
    );
  }

  async syncUser(idUser: number): Promise<boolean | undefined> {
    const { response, error } = await handleResponse<boolean, IResponseError>(
      Vue.$axios.post(`${BACKEND_BASE_URL}/api/configuration/v1/user/` + idUser + `/sync`)
    );
    if (error) {
      return false;
    } else {
      return response?.status === 200;
    }
  }

  async toggleFlowApprovalNotification(idUser: number): Promise<boolean | undefined> {
    const { response, error } = await handleResponse<boolean, IResponseError>(
      Vue.$axios.patch(
        `${BACKEND_BASE_URL}/api/configuration/v1/user/notification/flow-approval/${idUser}`
      )
    );
    if (error) {
      return false;
    } else {
      return response?.data;
    }
  }
}
